module.exports = __webpack_public_path__ + "10_mole.707d3569.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/10_mole.png
// module id = ajeb
// module chunks = 0